export default __webpack_public_path__ + "static/media/ethioair-icon.e7d6a960.svg";